export const InternalMutationKeys = {
  all: ["mutation", "internal"] as const,
  piloting: () => [...InternalMutationKeys.all, "piloting"] as const,
  siteProgram: () => [...InternalMutationKeys.all, "site-program"] as const,
  createSiteProgram: () => [...InternalMutationKeys.siteProgram(), "create"] as const,
  editSiteProgram: () => [...InternalMutationKeys.siteProgram(), "edit"] as const,
  renameSiteProgram: () => [...InternalMutationKeys.siteProgram(), "rename"] as const,
  activateSiteProgram: () => [...InternalMutationKeys.siteProgram(), "activate"] as const,
  deleteSiteProgram: () => [...InternalMutationKeys.siteProgram(), "delete"] as const,
  applyPlanningOverrides: () => [...InternalMutationKeys.piloting(), "apply-planning-overrides"] as const,
};
